import { webpackPlugin } from './index.ts';

export default webpackPlugin;
